<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">{{ alertMessage }}</h3>
                            <div class="has-text-centered">
                                <a class="button" @click="closeModal">close</a>
                                <a v-show="!isResponse" class="button is-primary" @click="triggerToZoho">YES</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['car'],
        computed: {
            isActive: function () {
                return this.$store.getters.getCarAlertModalStatus
            },
            alertMessage() {
                return this.$store.getters.getCarAlertMessage
            },
            isResponse() {
                return this.$store.getters.isResponse
            }
        },
        methods: {
            closeModal () {
                this.$store.dispatch('setCarAlertDetails', {carAlertMessage: null, carAlertModalStatus: false, carObj: null, triggerType: null, isResponse: false})
            },
            triggerToZoho () {
                if(this.$store.getters.getTriggerType == 'zoho_bill'){
                    this.$store.dispatch('triggerBill', this.$store.getters.getCarObj)
                }
                if(this.$store.getters.getTriggerType == 'zoho_invoice'){
                    this.$store.dispatch('triggerInvoice', this.$store.getters.getCarObj)
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/AlertCarModal.vue